module.exports = __webpack_public_path__ + "officialStatic/img/case51.e34b7da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case51.jpg
// module id = tSIK
// module chunks = 0